import { render } from "./HomeOfferOfTheDay.vue?vue&type=template&id=97bae24a"
import script from "./HomeOfferOfTheDay.vue?vue&type=script&lang=js"
export * from "./HomeOfferOfTheDay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__